import wretch from "wretch";
import {
  IPaymentStatusResponse,
  ICreatePaymentRequestResponse,
  IDisabledChannelsResponse,
  IQuoteResponse
} from "./payment.types";

const BASE_URL = process.env.NEXT_PUBLIC_EXTERNAL_BFF_URL || "";

export const getPaymentStatus = (
  paymentId: string
): Promise<{ data: IPaymentStatusResponse }> =>
  wretch(`${BASE_URL}/payments/v1/${paymentId}/status`).get().json();

export const createPaymentRequest = (
  paymentId: string,
  channelCode: string
): Promise<{ data: ICreatePaymentRequestResponse }> =>
  wretch(`${BASE_URL}/payments/v1/${paymentId}/payment_requests`)
    .post({ channel_code: channelCode })
    .json();

export const getDisabledChannels = (): Promise<{
  data: IDisabledChannelsResponse;
}> => wretch(`${BASE_URL}/payments/v1/channels/disabled`).get().json();

export const getQuote = (
  paymentId: string,
  channelCode: string
): Promise<{ data: IQuoteResponse }> =>
  wretch(
    `${BASE_URL}/payments/v1/${paymentId}/quote?channel_code=${channelCode}`
  )
    .get()
    .json();
